<template>
  <support />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    en: '/support',
    de: '/support',
    fr: '/support',
    es: '/support',
    // add more as needed
  },
});

// The Intercom messenger lives on the support pages only, not in the default
// layout: booting it loads the SDK and mints a Fin token, which should not
// happen because someone opened the homepage.
useSupportChat();

// SEO Configuration
const { t } = useI18n();
const config = useRuntimeConfig();
const route = useRoute();

useHead({
  title: () => t('support/page_title', 'Support | GPORTAL'),
});

useSeoMeta({
  title: () => t('support/page_title', 'Support | GPORTAL'),
  description: () =>
    t(
      'support/meta_description',
      'Get help with your GPORTAL services. Create support tickets, track your issues, and find answers to your questions.',
    ),
  ogTitle: () => t('support/page_title', 'Support | GPORTAL'),
  ogDescription: () =>
    t(
      'support/meta_description',
      'Get help with your GPORTAL services. Create support tickets, track your issues, and find answers to your questions.',
    ),
  ogImage: `https://ccdn.g-portal.com/support_ticket_bg_2b6ad96c34.png`,
  ogUrl: () => `${config.public.websiteUrl}${route.fullPath}`,
  ogImageAlt: () => t('support/page_title', 'Support | GPORTAL'),
  twitterTitle: () => t('support/page_title', 'Support | GPORTAL'),
  twitterDescription: () =>
    t(
      'support/meta_description',
      'Get help with your GPORTAL services. Create support tickets, track your issues, and find answers to your questions.',
    ),
  twitterImage: `https://ccdn.g-portal.com/support_ticket_bg_2b6ad96c34.png`,
  twitterImageAlt: () => t('support/page_title', 'Support | GPORTAL'),
});
</script>
